/**
 * Query Suggestions Database
 * Each suggestion has:
 * - text: The actual query suggestion
 * - category: Category for filtering (e.g., 'system', 'pe', 'network', 'file inspection', 'virustotal', 'registry', 'process')
 * - tags: Additional searchable tags
 */

export const querySuggestions = [
  // ========== file inspection GENERATION ==========
  {
    text: " find all PE files with specific import 'CreateRemoteThread' from kernel32.dll in current directory",
    category: "file inspection",
    tags: ["file inspection", "generator", "pe", "imports", "rule creation"]
  },
  {
    text: "detect all Windows drivers in this directory C:\\Windows\\System32\\drivers",
    category: "file inspection",
    tags: ["file inspection", "generator", "drivers", "windows", "rule creation"]
  },
  {
    text: "find files with .text section present in this directory C:\\Users\\cooluser\\Downloads",
    category: "file inspection",
    tags: ["file inspection", "generator", "sections", "pe", "rule creation"]
  },
  {
    text: "can you run below yara rule against this directory C:\\Users\\cooluser\\Downloads",
    category: "file inspection",
    tags: ["file inspection", "rule", "scan", "malware detection"]
  },
  {
    text: "Can you run below rule against all .dll files in C:\\Windows\\System32?",
    category: "file inspection",
    tags: ["file inspection", "dll", "scan", "system32", "windows"]
  },
  
  // ========== STRING EXTRACTION ==========
  {
    text: "extract all strings from file C:\\Users\\cooluser\\Downloads\\malware.exe",
    category: "strings",
    tags: ["strings", "extraction", "analysis", "file"]
  },
  {
    text: "can you list all strings that looks like ip address in this file C:\\Users\\cooluser\\Downloads\\dolphine.exe",
    category: "strings",
    tags: ["strings", "ip address", "analysis", "file"]
  },
  {
    text: "find all strings that look like URLs in sample.exe",
    category: "strings",
    tags: ["strings", "url", "analysis", "extraction"]
  },
  {
    text: "extract meaningful strings (not gibberish) from /tmp/suspicious_file",
    category: "strings",
    tags: ["strings", "meaningful", "analysis", "extraction"]
  },
  {
    text: "Can you search for all files that have credit-card-like patterns (e.g., 16-digit numbers) in  /Users/cooluser/Downloads",
    category: "strings",
    tags: ["patterns", "credit card", "pii", "sensitive data", "regex"]
  },
  
  // ========== PROCESS MANAGEMENT ==========
  {
    text: "list all running processes on this machine",
    category: "process",
    tags: ["processes", "list", "running", "system", "all"]
  },
  {
    text: "show me top 10 processes consuming most CPU",
    category: "process",
    tags: ["processes", "cpu", "performance", "top", "usage"]
  },
  {
    text: "which processes are using more than 500MB of memory?",
    category: "process",
    tags: ["processes", "memory", "ram", "threshold", "usage"]
  },
  {
    text: "show me top 5 processes by memory usage sorted",
    category: "process",
    tags: ["processes", "memory", "sorted", "top", "performance"]
  },
  {
    text: "find all python processes running on this system",
    category: "process",
    tags: ["processes", "find", "search", "python", "name"]
  },
  {
    text: "is chrome process running? show me details",
    category: "process",
    tags: ["processes", "find", "chrome", "browser", "running"]
  },
  {
    text: "get complete information for process ID 1234",
    category: "process",
    tags: ["process", "pid", "details", "info", "specific"]
  },
  {
    text: "show command line for firefox process",
    category: "process",
    tags: ["process", "command line", "arguments", "firefox", "cmdline"]
  },
  {
    text: "what is the full command line for PID 5678?",
    category: "process",
    tags: ["process", "pid", "command line", "full", "arguments"]
  },
  {
    text: "get binary path of chrome process",
    category: "process",
    tags: ["process", "binary", "executable", "path", "chrome"]
  },
  {
    text: "show executable location for PID 9876",
    category: "process",
    tags: ["process", "pid", "executable", "binary", "path"]
  },
  {
    text: "what network connections does chrome have?",
    category: "process",
    tags: ["process", "network", "connections", "sockets", "chrome"]
  },
  {
    text: "show all network connections for PID 4321",
    category: "process",
    tags: ["process", "pid", "network", "connections", "ports"]
  },
  {
    text: "list all processes started by user john",
    category: "process",
    tags: ["processes", "user", "owner", "filter", "specific"]
  },
  {
    text: "can you show me all processes run by root user",
    category: "process",
    tags: ["processes", "root", "admin", "user", "privileges"]
  },
  {
    text: "get system-wide process statistics",
    category: "process",
    tags: ["processes", "statistics", "system", "summary", "stats"]
  },
  {
    text: "how many processes are currently running?",
    category: "process",
    tags: ["processes", "count", "total", "statistics", "system"]
  },
  {
    text: "show all information about process opendirectoryd",
    category: "process",
    tags: ["process", "info", "details", "specific", "system"]
  },
  {
    text: "get working directory for PID 2468",
    category: "process",
    tags: ["process", "pid", "cwd", "directory", "path"]
  },
  {
    text: "find all node processes and show their CPU usage",
    category: "process",
    tags: ["processes", "node", "cpu", "usage", "find"]
  },
  
  // ========== PE/ELF/MACH-O HEADER ANALYSIS ==========
  {
    text: "print me the pe header of this file C:\\Users\\cooluser\\Downloads\\dolphine.exe",
    category: "pe",
    tags: ["pe header", "executable", "analysis", "windows"]
  },
  {
    text: "show me all sections in the ELF binary /usr/bin/ls",
    category: "pe",
    tags: ["elf", "sections", "header", "linux"]
  },
  {
    text: "print me the pe section headers of this file C:\\Users\\cooluser\\Downloads\\dolphine.exe",
    category: "pe",
    tags: ["pe sections", "executable", "analysis", "windows"]
  },
  {
    text: "show me all the imports of this file C:\\Users\\cooluser\\Downloads\\dolphine.exe",
    category: "pe",
    tags: ["imports", "dll", "api", "pe analysis", "windows"]
  },
  {
    text: "print me the pe resources of this file C:\\Users\\cooluser\\Downloads\\dolphine.exe",
    category: "pe",
    tags: ["pe resources", "executable", "analysis", "windows"]
  },
  {
    text: "display the entry point of malware.exe",
    category: "pe",
    tags: ["pe header", "entry point", "executable", "analysis"]
  },
  {
    text: "what is the machine type of this PE file sample.dll?",
    category: "pe",
    tags: ["pe header", "machine type", "architecture", "analysis"]
  },
  
  // ========== MALICIOUSNESS VERDICT ==========
  {
    text: "is following file malicious dolphine.exe",
    category: "verdict",
    tags: ["malicious", "verdict", "analysis", "detection"]
  },
  {
    text: "analyze if sample.bin is benign or malware",
    category: "verdict",
    tags: ["malicious", "benign", "verdict", "analysis"]
  },
  {
    text: "give me a security verdict for C:\\Windows\\System32\\suspicious.dll",
    category: "verdict",
    tags: ["verdict", "security", "analysis", "malware"]
  },
  
  // ========== SYSTEM INFORMATION ==========
  {
    text: "can you print all nvram variable in this macos machine",
    category: "system",
    tags: ["nvram", "variables", "system info", "hardware"]
  },
  {
    text: "can you tell me what disk partitions are there in this machine",
    category: "system",
    tags: ["disk", "partitions", "storage", "hardware"]
  },
  {
    text: "can you check system uptime and load average",
    category: "system",
    tags: ["uptime", "load", "performance", "system info"]
  },
  {
    text: "Can you print the system's BIOS/UEFI information (vendor, version, serial number)?",
    category: "system",
    tags: ["bios", "uefi", "firmware", "hardware", "system info"]
  },
  {
    text: "list all installed kernel modules/drivers on this machine",
    category: "system",
    tags: ["kernel", "modules", "drivers", "system"]
  },
  {
    text: "show me the current CPU usage and temperature",
    category: "system",
    tags: ["cpu", "performance", "temperature", "system info"]
  },
  
  // ========== FILE DISASSEMBLY ==========
  {
    text: "disassemble the function at address 0x401000 in malware.exe",
    category: "disassembly",
    tags: ["disassembly", "assembly", "reverse engineering", "analysis"]
  },
  {
    text: "show me the complete disassembly of sample.bin",
    category: "disassembly",
    tags: ["disassembly", "assembly", "reverse engineering", "analysis"]
  },
  {
    text: "find all 'call' instructions in the disassembly of suspicious.exe",
    category: "disassembly",
    tags: ["disassembly", "instructions", "opcodes", "analysis"]
  },
  
  // ========== COMMAND EXECUTION / CLI ADVANCED ==========
  {
    text: "execute command 'netstat -an' on this machine",
    category: "command",
    tags: ["command", "execution", "cli", "netstat", "network"]
  },
  {
    text: "run 'ps aux' and show me all running processes",
    category: "command",
    tags: ["command", "execution", "processes", "linux"]
  },
  {
    text: "Can you list all network interfaces and their IP/MAC addresses?",
    category: "network",
    tags: ["network", "interfaces", "ip", "mac address"]
  },
  {
    text: "Can you display all open/listening TCP and UDP ports?",
    category: "network",
    tags: ["ports", "tcp", "udp", "network", "connections"]
  },
  {
    text: "can you list all environment variables in this machine",
    category: "system",
    tags: ["environment", "variables", "system", "info"]
  },
  
  // ========== TTP EXTRACTION ==========
  {
    text: "Can you extract the TTPs of this file C:\\Users\\cooluser\\Downloads\\dolphine.exe",
    category: "ttp",
    tags: ["ttp", "tactics", "techniques", "mitre", "malware"]
  },
  {
    text: "what MITRE ATT&CK techniques are present in ransomware.exe?",
    category: "ttp",
    tags: ["ttp", "mitre", "attack", "techniques", "malware"]
  },
  {
    text: "Can you find any encryption logic in this file dolphine.exe",
    category: "ttp",
    tags: ["encryption", "crypto", "analysis", "malware", "ttp"]
  },
  {
    text: "show me all capabilities detected in /tmp/malware_sample",
    category: "ttp",
    tags: ["ttp", "capabilities", "capa", "analysis"]
  },
  
  // ========== VIRUSTOTAL SCAN ==========
  {
    text: "scan this file hash on VirusTotal: 44d88612fea8a8f36de82e1278abb02f",
    category: "virustotal",
    tags: ["virustotal", "scan", "hash", "malware detection"]
  },
  {
    text: "check this URL on VirusTotal: http://suspicious-site.com",
    category: "virustotal",
    tags: ["virustotal", "url", "scan", "phishing"]
  },
  {
    text: "analyze IP address 8.8.8.8 on VirusTotal",
    category: "virustotal",
    tags: ["virustotal", "ip", "scan", "analysis"]
  },
  {
    text: "check domain example.com on VirusTotal",
    category: "virustotal",
    tags: ["virustotal", "domain", "scan", "analysis"]
  },
  
  // ========== OPENTIP SCAN (Kaspersky) ==========
  {
    text: "scan this file hash on Kaspersky OpenTIP: abc123def456",
    category: "opentip",
    tags: ["opentip", "kaspersky", "scan", "hash"]
  },
  {
    text: "check this URL on OpenTIP: https://suspicious-link.com",
    category: "opentip",
    tags: ["opentip", "kaspersky", "url", "scan"]
  },
  {
    text: "get full analysis for hash 44d88612fea8a8f36de82e1278abb02f from Kaspersky OpenTIP",
    category: "opentip",
    tags: ["opentip", "kaspersky", "analysis", "detailed"]
  },
  {
    text: "analyze domain evil.com on Kaspersky OpenTIP",
    category: "opentip",
    tags: ["opentip", "kaspersky", "domain", "scan"]
  },
  
  // ========== DOMAIN RESEARCH ==========
  {
    text: "whois lookup for example.com",
    category: "domain",
    tags: ["whois", "domain", "research", "registration"]
  },
  {
    text: "check DNS records for google.com",
    category: "domain",
    tags: ["dns", "domain", "lookup", "records"]
  },
  {
    text: "get SSL certificate information for github.com",
    category: "domain",
    tags: ["ssl", "certificate", "domain", "https"]
  },
  {
    text: "is domain mydomain.com available for registration?",
    category: "domain",
    tags: ["domain", "availability", "registration", "check"]
  },
  {
    text: "how old is the domain google.com?",
    category: "domain",
    tags: ["domain", "age", "whois", "registration"]
  },
  {
    text: "get MX records for example.com",
    category: "domain",
    tags: ["dns", "mx", "mail", "domain"]
  },
  
  // ========== MALWAREBAZAAR QUERY ==========
  {
    text: "show me recent malware samples from MalwareBazaar",
    category: "malwarebazaar",
    tags: ["malwarebazaar", "abuse.ch", "malware", "samples"]
  },
  {
    text: "lookup hash 5f4dcc3b5aa765d61d8327deb882cf99 in MalwareBazaar",
    category: "malwarebazaar",
    tags: ["malwarebazaar", "hash", "lookup", "malware"]
  },
  {
    text: "show me malware samples tagged with ransomware from MalwareBazaar",
    category: "malwarebazaar",
    tags: ["malwarebazaar", "tags", "ransomware", "malware"]
  },
  {
    text: "get latest 20 malware samples from MalwareBazaar",
    category: "malwarebazaar",
    tags: ["malwarebazaar", "recent", "samples", "malware"]
  },
  {
    text: "show samples with tag emotet from MalwareBazaar",
    category: "malwarebazaar",
    tags: ["malwarebazaar", "recent", "samples", "malware"]
  },
  
  // ========== THREATFOX QUERY ==========
  {
    text: "get recent IOCs from ThreatFox",
    category: "threatfox",
    tags: ["threatfox", "abuse.ch", "ioc", "indicators"]
  },
  {
    text: "lookup IOC 1.2.3.4 in ThreatFox",
    category: "threatfox",
    tags: ["threatfox", "ioc", "lookup", "ip"]
  },
  {
    text: "search for Emotet IOCs in ThreatFox",
    category: "threatfox",
    tags: ["threatfox", "malware", "family", "emotet"]
  },
  {
    text: "show me ransomware IOCs from ThreatFox",
    category: "threatfox",
    tags: ["threatfox", "ransomware", "ioc", "malware"]
  },
  {
    text: "get latest IOCs for Cobalt Strike from ThreatFox",
    category: "threatfox",
    tags: ["threatfox", "cobalt strike", "ioc", "malware"]
  },
  {
    text: "check if this IP 192.0.2.1 is in ThreatFox",
    category: "threatfox",
    tags: ["threatfox", "ip", "ioc", "lookup"]
  },
  
  // ========== URLHAUS QUERY ==========
  {
    text: "lookup URL http://malicious.com/payload.exe in URLhaus",
    category: "urlhaus",
    tags: ["urlhaus", "abuse.ch", "url", "malicious"]
  },
  {
    text: "check host evil.com in URLhaus",
    category: "urlhaus",
    tags: ["urlhaus", "host", "domain", "malicious"]
  },
  {
    text: "show recent malicious URLs from URLhaus",
    category: "urlhaus",
    tags: ["urlhaus", "recent", "urls", "malicious"]
  },
  {
    text: "find URLs distributing payload hash abc123 in URLhaus",
    category: "urlhaus",
    tags: ["urlhaus", "payload", "hash", "distribution"]
  },
  
  // ========== URLDNA SCAN ==========
  {
    text: "scan this URL on urlDNA: http://suspicious-site.com",
    category: "urldna",
    tags: ["urldna", "url", "scan", "phishing"]
  },
  {
    text: "check if this URL is phishing on urlDNA: http://evil.com",
    category: "urldna",
    tags: ["urldna", "phishing", "url", "scan"]
  },
  {
    text: "submit URL http://test.com to urlDNA for analysis",
    category: "urldna",
    tags: ["urldna", "url", "submit", "scan"]
  },
  
  // ========== ABUSEIPDB ==========
  {
    text: "check IP 134.122.87.122 on abuseipdb",
    category: "abuseipdb",
    tags: ["abuseipdb", "ip", "reputation", "check"]
  },
  {
    text: "lookup 8.8.8.8 for abuse reports",
    category: "abuseipdb",
    tags: ["abuseipdb", "ip", "abuse", "lookup"]
  },
  {
    text: "is 192.168.1.100 malicious on abuseipdb?",
    category: "abuseipdb",
    tags: ["abuseipdb", "ip", "malicious", "check"]
  },
  {
    text: "get abuse confidence score for 1.2.3.4",
    category: "abuseipdb",
    tags: ["abuseipdb", "ip", "confidence", "score"]
  },
  {
    text: "report IP 203.0.113.50 for SSH brute force on abuseipdb",
    category: "abuseipdb",
    tags: ["abuseipdb", "ip", "report", "ssh", "brute-force"]
  },
  {
    text: "submit IP 10.0.0.1 to abuseipdb for DDoS attack",
    category: "abuseipdb",
    tags: ["abuseipdb", "ip", "report", "ddos"]
  },
  
  // ========== CHECKSEC ANALYSIS ==========
  {
    text: "check security features of this binary /usr/bin/ls",
    category: "filesec",
    tags: ["filesec", "security", "binary", "analysis"]
  },
  {
    text: "check security features of malware.exe",
    category: "filesec",
    tags: ["filesec", "security", "pe", "analysis"]
  },
  {
    text: "is ASLR enabled for C:\\Windows\\System32\\notepad.exe?",
    category: "filesec",
    tags: ["filesec", "aslr", "security", "pe"]
  },
  {
    text: "does sample.elf have stack canary protection?",
    category: "filesec",
    tags: ["filesec", "canary", "security", "elf"]
  },
  
  // ========== PROCESS INSTRUMENTATION (Dynamic Analysis) ==========
  {
    text: "list all running processes on this machine",
    category: "process inspection",
    tags: ["process inspection", "processes", "instrumentation", "dynamic", "list"]
  },
  {
    text: "attach to Chrome process and monitor it",
    category: "process inspection",
    tags: ["process inspection", "attach", "monitor", "instrumentation", "browser"]
  },
  {
    text: "hook CreateFileW in notepad.exe",
    category: "process inspection",
    tags: ["process inspection", "hook", "api", "instrumentation", "file operations"]
  },
  {
    text: "trace CreateFileW, ReadFile, WriteFile in process 1234",
    category: "process inspection",
    tags: ["process inspection", "trace", "api", "instrumentation", "file io"]
  },
  {
    text: "hook malloc and free in chrome",
    category: "process inspection",
    tags: ["process inspection", "hook", "memory", "instrumentation", "allocation"]
  },
  {
    text: "monitor RegOpenKeyExW and RegSetValueExW in regedit.exe",
    category: "process inspection",
    tags: ["process inspection", "monitor", "registry", "instrumentation", "windows"]
  },
  {
    text: "trace all API calls in firefox for 20 seconds",
    category: "process inspection",
    tags: ["process inspection", "trace", "api", "instrumentation", "monitoring"]
  },
  {
    text: "hook the open, read, write functions in /usr/bin/cat",
    category: "process inspection",
    tags: ["process inspection", "hook", "syscall", "instrumentation", "linux"]
  },
  {
    text: "intercept network calls in process 5678",
    category: "process inspection",
    tags: ["process inspection", "intercept", "network", "instrumentation", "monitoring"]
  },
  {
    text: "list all strings in process 8584 with minimum 5 characters",
    category: "process inspection",
    tags: ["process inspection", "strings", "memory", "instrumentation", "extraction"]
  },
  {
    text: "extract strings from notepad.exe process for 15 seconds",
    category: "process inspection",
    tags: ["process inspection", "strings", "memory scan", "instrumentation", "dynamic"]
  },
  {
    text: "trace file operations in Microsoft Word",
    category: "process inspection",
    tags: ["process inspection", "trace", "file", "instrumentation", "office"]
  },
  {
    text: "hook CreateProcessW in process 1234",
    category: "process inspection",
    tags: ["process inspection", "hook", "process creation", "instrumentation", "windows"]
  },
  {
    text: "monitor all function calls from kernel32.dll in notepad.exe",
    category: "process inspection",
    tags: ["process inspection", "monitor", "module", "instrumentation", "dll"]
  },
  {
    text: "show all trace files saved",
    category: "process inspection",
    tags: ["process inspection", "traces", "logs", "instrumentation", "history"]
  },
  {
    text: "attach to process 9876 and hook VirtualAlloc",
    category: "process inspection",
    tags: ["process inspection", "attach", "hook", "memory", "instrumentation"]
  },
  {
    text: "trace socket, connect, send, recv in chrome",
    category: "process inspection",
    tags: ["process inspection", "trace", "network", "instrumentation", "sockets"]
  },
  {
    text: "inject custom script to monitor CreateRemoteThread in explorer.exe",
    category: "process inspection",
    tags: ["process inspection", "inject", "hook", "instrumentation", "process injection"]
  },
  {
    text: "scan memory for strings containing 'password' in process 4321",
    category: "process inspection",
    tags: ["process inspection", "memory scan", "strings", "instrumentation", "search"]
  },
  {
    text: "hook all libc.so.6 functions in python process",
    category: "process inspection",
    tags: ["process inspection", "hook", "library", "instrumentation", "linux"]
  },
  
  // ========== REGISTRY (Windows) ==========
  {
    text: "Can you list all subkeys under HKLM\\Software\\Microsoft\\Windows\\CurrentVersion\\Run?",
    category: "registry",
    tags: ["registry", "windows", "autorun", "persistence"]
  },
  {
    text: "read registry key HKCU\\Software\\MyApp\\Settings",
    category: "registry",
    tags: ["registry", "windows", "read", "settings"]
  },
  {
    text: "query registry value 'ProgramFilesDir' from HKLM\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion",
    category: "registry",
    tags: ["registry", "windows", "query", "value"]
  },
  {
    text: "list all values in registry key HKCU\\Environment",
    category: "registry",
    tags: ["registry", "windows", "list", "environment"]
  },
  {
    text: "check registry key HKLM\\SYSTEM\\CurrentControlSet\\Services",
    category: "registry",
    tags: ["registry", "windows", "services", "system"]
  },
  {
    text: "read registry value 'ProductName' from HKLM\\SOFTWARE\\Microsoft\\Windows NT\\CurrentVersion",
    category: "registry",
    tags: ["registry", "windows", "version", "info"]
  },
  {
    text: "list all startup programs from HKCU\\Software\\Microsoft\\Windows\\CurrentVersion\\Run",
    category: "registry",
    tags: ["registry", "windows", "startup", "autorun"]
  },
  {
    text: "query HKLM\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion\\Uninstall for installed programs",
    category: "registry",
    tags: ["registry", "windows", "programs", "installed"]
  },
  {
    text: "check if registry key HKCU\\Software\\MalwareApp exists",
    category: "registry",
    tags: ["registry", "windows", "check", "malware"]
  },
  {
    text: "get Windows version from registry HKLM\\SOFTWARE\\Microsoft\\Windows NT\\CurrentVersion",
    category: "registry",
    tags: ["registry", "windows", "version", "os"]
  },
  {
    text: "list all network adapters from HKLM\\SYSTEM\\CurrentControlSet\\Control\\Class\\{4D36E972-E325-11CE-BFC1-08002bE10318}",
    category: "registry",
    tags: ["registry", "windows", "network", "adapters"]
  },
  {
    text: "read registry key HKLM\\SOFTWARE\\Policies\\Microsoft\\Windows Defender",
    category: "registry",
    tags: ["registry", "windows", "defender", "security"]
  },
  
  // ========== CRASH DUMP ANALYSIS (WinDbg) ==========
  {
    text: "list all crash dump files",
    category: "crash analysis",
    tags: ["windbg", "crash", "dump", "list", "windows"]
  },
  {
    text: "can you list all windbg dump files in C:\\CrashDumps",
    category: "crash analysis",
    tags: ["windbg", "crash", "dump", "list", "directory"]
  },
  {
    text: "analyze the crash dump at C:\\CrashDumps\\app.exe.1234.dmp",
    category: "crash analysis",
    tags: ["windbg", "crash", "analyze", "dump", "debugging"]
  },
  {
    text: "what caused the crash in the latest dump file?",
    category: "crash analysis",
    tags: ["windbg", "crash", "root cause", "analysis"]
  },
  {
    text: "show stack trace from the crash dump",
    category: "crash analysis",
    tags: ["windbg", "crash", "stack trace", "debugging"]
  },
  {
    text: "get stack trace from all threads in the crash dump",
    category: "crash analysis",
    tags: ["windbg", "crash", "stack", "threads", "debugging"]
  },
  {
    text: "run !analyze -v on C:\\CrashDumps\\app.exe.1234.dmp",
    category: "crash analysis",
    tags: ["windbg", "crash", "analyze", "command", "debugging"]
  },
  {
    text: "show loaded modules from the crash dump",
    category: "crash analysis",
    tags: ["windbg", "crash", "modules", "dll", "debugging"]
  },
  {
    text: "what exception occurred in the crash?",
    category: "crash analysis",
    tags: ["windbg", "crash", "exception", "error", "debugging"]
  },
  {
    text: "analyze heap corruption in C:\\CrashDumps\\critical_crash.8544.dmp",
    category: "crash analysis",
    tags: ["windbg", "crash", "heap", "corruption", "memory"]
  },
  {
    text: "show heap summary from the crash dump",
    category: "crash analysis",
    tags: ["windbg", "crash", "heap", "memory", "debugging"]
  },
  {
    text: "execute kb command on the crash dump",
    category: "crash analysis",
    tags: ["windbg", "crash", "command", "stack", "debugging"]
  },
  {
    text: "why did the application crash?",
    category: "crash analysis",
    tags: ["windbg", "crash", "root cause", "analysis", "debugging"]
  },
  {
    text: "analyze null pointer dereference in the dump",
    category: "crash analysis",
    tags: ["windbg", "crash", "nullptr", "access violation", "debugging"]
  },
  {
    text: "get exception details from C:\\CrashDumps\\crash.dmp",
    category: "crash analysis",
    tags: ["windbg", "crash", "exception", "details", "debugging"]
  },
  {
    text: "analyze memory corruption in the crash dump abc.exe.1234.dmp",
    category: "crash analysis",
    tags: ["windbg", "crash", "memory", "corruption", "debugging"]
  },
  
  // ========== MULTI-ACTION / AUTONOMOUS AGENT ==========
  {
    text: "find all IP addresses in file dolphin.exe and scan them on VirusTotal",
    category: "autonomous",
    tags: ["autonomous", "multi-action", "ip", "virustotal", "strings"]
  },
  {
    text: "extract strings from malware.exe, find URLs, and check them on urlDNA",
    category: "autonomous",
    tags: ["autonomous", "multi-action", "strings", "urldna", "urls"]
  },
  {
    text: "extract TTPs from ransomware.exe and then scan its hash on VirusTotal",
    category: "autonomous",
    tags: ["autonomous", "multi-action", "ttp", "virustotal", "hash"]
  },
  {
    text: "disassemble malware.bin, find encryption functions and check if it is malicious",
    category: "autonomous",
    tags: ["autonomous", "multi-action", "disassembly", "encryption", "analysis"]
  },
  {
    text: "scan this file hash on VirusTotal and if malicious, extract all TTPs from the file",
    category: "autonomous",
    tags: ["autonomous", "multi-action", "virustotal", "ttp", "conditional"]
  },
  {
    text: "extract domains from config.txt and check their reputation on VirusTotal",
    category: "autonomous",
    tags: ["autonomous", "multi-action", "domains", "virustotal", "reputation"]
  },
  {
    text: "list all pe files in Downloads, extract their hashes, and scan on MalwareBazaar",
    category: "autonomous",
    tags: ["autonomous", "multi-action", "hash", "malwarebazaar", "scan"]
  },
  {
    text: "analyze security of kernel.bin with checksec and verify if it has dangerous imports",
    category: "autonomous",
    tags: ["autonomous", "multi-action", "checksec", "imports", "security"]
  },
];

/**
 * Get all unique categories from suggestions
 */
export const getCategories = () => {
  const categories = new Set(querySuggestions.map(s => s.category));
  return Array.from(categories).sort();
};

/**
 * Filter suggestions by search query
 */
export const filterSuggestions = (searchQuery) => {
  if (!searchQuery || searchQuery.trim() === '') {
    return querySuggestions;
  }
  
  const query = searchQuery.toLowerCase().trim();
  
  return querySuggestions.filter(suggestion => {
    // Check if query matches text
    if (suggestion.text.toLowerCase().includes(query)) {
      return true;
    }
    
    // Check if query matches category
    if (suggestion.category.toLowerCase().includes(query)) {
      return true;
    }
    
    // Check if query matches any tag
    if (suggestion.tags.some(tag => tag.toLowerCase().includes(query))) {
      return true;
    }
    
    return false;
  });
};

/**
 * Get random suggestions from all or filtered suggestions
 */
export const getRandomSuggestions = (count = 5, searchQuery = '') => {
  const suggestions = searchQuery ? filterSuggestions(searchQuery) : querySuggestions;
  const shuffled = [...suggestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, suggestions.length));
};

export default querySuggestions;

